export default __webpack_public_path__ + "static/media/25.4cf614ae.jpg";